module.exports = __webpack_public_path__ + "assets/imgs/banners/heroimage-NZ.jpg";